import {Slider} from "@mui/material";
import React from "react";

export const FilterRangeSlider = ({
    value,
    onChange,
    min,
    max,
    step,
}: {
    value: number[],
    onChange: (newValue: number[]) => void,
    min: number,
    max: number,
    step: number
}) => {
    return (
        <Slider
            value={value}
            onChange={(e, newValue) => onChange(newValue as number[])}
            valueLabelDisplay="auto"
            min={min}
            max={max}
            step={step}
        />
    );
};
